export default "__VITE_ASSET__VeiYtRi$__"